import React from 'react';

const MapSearchPanel = ({
  query,
  results,
  activeIndex,
  isDarkMode,
  onActiveIndexChange,
  onSelectResult,
}) => {
  const foreground = isDarkMode ? '#f7f7f8' : '#171719';
  const surface = isDarkMode ? 'rgba(39, 39, 42, 0.98)' : 'rgba(255, 255, 255, 0.98)';
  const border = isDarkMode ? '#52525b' : '#d4d4d8';

  return (
    <div
      id="map-search-results"
      role="dialog"
      aria-label="Search map results"
      data-export-ignore="true"
      data-viewport-occlusion="true"
      onPointerDown={(event) => {
        // Keep panel interaction out of the canvas gesture system. Focus may
        // move to a result button so keyboard and touch scrolling still work.
        event.stopPropagation();
      }}
      style={{
        position: 'absolute', top: 'calc(100% + 8px)', right: 0,
        width: 'min(420px, calc(100vw - 24px))', zIndex: 220, color: foreground,
        background: surface, border: `1px solid ${border}`, borderRadius: 12,
        boxShadow: '0 16px 50px rgba(0, 0, 0, 0.28)', overflow: 'hidden',
      }}
    >
      {query && (
        <div
          role="listbox"
          aria-label="Idea search results"
          style={{ maxHeight: 320, overflowY: 'auto' }}
        >
          {results.map((result, index) => (
            <button
              key={result.node.id}
              id={`map-search-result-${result.node.id}`}
              type="button"
              role="option"
              aria-selected={index === activeIndex}
              onMouseEnter={() => onActiveIndexChange(index)}
              onClick={() => onSelectResult(result.node.id)}
              style={{
                display: 'block', width: '100%', padding: '10px 14px', border: 0,
                borderBottom: index < results.length - 1 ? `1px solid ${border}` : 0,
                background: index === activeIndex
                  ? (isDarkMode ? '#3f3f46' : '#f4f4f5')
                  : 'transparent',
                color: foreground, textAlign: 'left', cursor: 'pointer',
              }}
            >
              <span style={{ display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {result.label}
              </span>
              {result.node.linkUrl && (
                <span style={{ display: 'block', fontSize: 12, opacity: 0.65, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {result.node.linkUrl}
                </span>
              )}
            </button>
          ))}
          {!results.length && <div style={{ padding: 14, opacity: 0.7 }}>No matching ideas</div>}
        </div>
      )}
      {!query && (
        <div style={{ padding: '12px 14px', opacity: 0.7 }}>
          Type to search every idea
        </div>
      )}
      <div style={{
        padding: '6px 12px',
        borderTop: `1px solid ${border}`,
        fontSize: 11,
        opacity: 0.65,
      }}>
        ↑↓ navigate · Enter reveal · Esc dismiss
      </div>
    </div>
  );
};

export default MapSearchPanel;
